"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _throttle = _interopRequireDefault(require("lodash/throttle"));
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _search = _interopRequireDefault(require("@spothero/icons/search"));
var _environment = _interopRequireDefault(require("@spothero/utils/environment"));
var _AutoSuggestInput = _interopRequireDefault(require("../AutoSuggestInput/AutoSuggestInput"));
var _TextInputPropTypes = _interopRequireDefault(require("../TextInput/TextInputPropTypes"));
var _isEqual = _interopRequireDefault(require("lodash/isEqual"));
var _omit = _interopRequireDefault(require("lodash/omit"));
var _debounce = _interopRequireDefault(require("lodash/debounce"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const mapNewSuggestionsToLegacySuggestions = newSuggestions => {
  return newSuggestions?.map(suggestion => {
    return {
      description: suggestion?.placePrediction?.text?.text || '',
      place_id: suggestion?.placePrediction?.placeId || '',
      distance_meters: suggestion?.placePrediction?.distanceMeters || 0,
      matched_substrings: suggestion?.placePrediction?.text?.matches.map(match => ({
        length: match?.endOffset,
        offset: match?.startOffset
      })) || [],
      terms: suggestion?.placePrediction?.secondaryText?.text,
      types: suggestion?.placePrediction?.types,
      label: suggestion?.placePrediction?.text?.text || '',
      id: suggestion?.placePrediction?.placeId || ''
    };
  });
};
class GooglePlacesSearchInput extends _react.Component {
  static defaultProps = {
    placeholder: 'Search Address or Venue',
    country: 'us',
    icon: /*#__PURE__*/_react.default.createElement(_search.default, null),
    appendToGoogleSuggestions: false,
    useNewGooglePlacesApi: false
  };
  constructor(props) {
    super(props);
    const {
      googleMaps
    } = props;
    const isBrowser = _environment.default.isBrowser();
    this._suggestionFetch = this.props.useNewGooglePlacesApi ? (0, _debounce.default)(this._searchSuggestions, 500) : (0, _throttle.default)(this._searchSuggestionsLegacy, 500);
    this._gmaps = googleMaps;
    this._autocompleteService = isBrowser ? new this._gmaps.places.AutocompleteService() : null;
    this._geocoder = isBrowser ? new this._gmaps.Geocoder() : null;
    this.state = {
      suggestions: [],
      autocompleteSessionToken: isBrowser ? new this._gmaps.places.AutocompleteSessionToken() : null,
      onLoad: true
    };
  }
  componentDidUpdate(prevProps) {
    const {
      additionalSuggestions,
      appendToGoogleSuggestions
    } = this.props;
    const {
      additionalSuggestions: prevAdditionalSuggestions
    } = prevProps;
    const {
      suggestions,
      onLoad
    } = this.state;

    // This avoids unnecessary rerenders
    const prevAdditionalSuggestionsToCompare = prevAdditionalSuggestions?.map(pre => (0, _omit.default)(pre, 'componentToRender')) || [];
    const additionalSuggestionsToCompare = additionalSuggestions?.map(cus => (0, _omit.default)(cus, 'componentToRender')) || [];

    // Setting the suggestions will open the dropdown.
    // On component load the suggestions update is avoided and the suggestion is set only onFocus.
    const shouldUpdate = !onLoad && !(0, _isEqual.default)(prevAdditionalSuggestionsToCompare, additionalSuggestionsToCompare) && appendToGoogleSuggestions;
    if (shouldUpdate) {
      const googleSuggestions = suggestions?.filter(sug => sug?.place_id) || [];
      // The suggestions and custom suggestions are combined for highlighting the active suggestions and to support keyboard interactions
      this.setState({
        suggestions: [...googleSuggestions, ...additionalSuggestions]
      });
    } else if (!onLoad && !suggestions?.length && additionalSuggestions?.length) {
      // The additional suggestions might be same but requires to set suggestions when its reset to null
      this.setState({
        suggestions: [...additionalSuggestions]
      });
    }
  }
  _onFocus = _evt => {
    const {
      additionalSuggestions,
      appendToGoogleSuggestions
    } = this.props;
    const {
      suggestions: prevSuggestions
    } = this.state;
    this.setState({
      suggestions: prevSuggestions && prevSuggestions?.length > 0 && appendToGoogleSuggestions ? prevSuggestions : additionalSuggestions,
      onLoad: false
    });
  };
  _onChange = evt => {
    const {
      onChange,
      additionalSuggestions
    } = this.props;
    const {
      autocompleteSessionToken
    } = this.state;
    const value = evt.target.value;
    if (!autocompleteSessionToken) {
      this.setState({
        autocompleteSessionToken: new this._gmaps.places.AutocompleteSessionToken()
      });
    }
    if (!value || value.length < 3) {
      this._suggestionFetch.cancel();
      this.setState({
        suggestions: additionalSuggestions || []
      });
    } else {
      this._suggestionFetch(value);
    }
    if (onChange) {
      onChange(evt);
    }
  };
  _onSuggestionSelect = suggestion => {
    const {
      onSuggestionSelect
    } = this.props;
    const {
      place_id: placeId,
      description
    } = suggestion;
    if (suggestion?.location) {
      onSuggestionSelect(suggestion);
    } else {
      this._geocoder.geocode(placeId ? {
        placeId
      } : {
        address: description
      }, (results, status) => {
        if (status !== this._gmaps.GeocoderStatus.OK) {
          return;
        }
        const gmaps = results[0];
        const geoCodedLocation = gmaps.geometry.location;
        suggestion.label = description;
        suggestion.gmaps = gmaps;
        suggestion.location = {
          lat: geoCodedLocation.lat(),
          lng: geoCodedLocation.lng()
        };
        onSuggestionSelect(suggestion);
      });
    }
    this.setState({
      autocompleteSessionToken: null
    });
  };
  _searchSuggestionsLegacy = value => {
    const {
      country,
      types,
      bounds,
      biasOptions,
      onSuggestionFetched
    } = this.props;
    const {
      autocompleteSessionToken
    } = this.state;
    const options = {
      input: value,
      ...(country && {
        componentRestrictions: {
          country
        }
      }),
      ...(types && {
        types
      }),
      ...(bounds && {
        locationBias: bounds
      }),
      ...(biasOptions && {
        locationBias: new this._gmaps.Circle({
          center: new this._gmaps.LatLng(biasOptions?.location?.latitude, biasOptions?.location?.longitude),
          radius: biasOptions?.radius
        })
      }),
      sessionToken: autocompleteSessionToken
    };
    this._autocompleteService.getPlacePredictions(options, suggestions => {
      if (typeof onSuggestionFetched === 'function') {
        onSuggestionFetched(value, suggestions);
      }
      if (suggestions) {
        suggestions.map(suggestion => {
          suggestion.label = suggestion.description;
          if (!suggestion.id) {
            suggestion.id = suggestion.place_id;
          }
          return suggestion;
        });
      }
      this.setState({
        suggestions
      });
    });
  };
  _searchSuggestions = async value => {
    if (this._gmaps && this._gmaps.places) {
      try {
        const {
          biasOptions
        } = this.props;
        const options = {
          input: value,
          ...(biasOptions && {
            locationBias: new this._gmaps.Circle({
              center: new this._gmaps.LatLng(biasOptions?.location?.latitude, biasOptions?.location?.longitude),
              radius: biasOptions?.radius
            })
          })
        };
        const {
          suggestions
        } = await this._gmaps.places.AutocompleteSuggestion?.fetchAutocompleteSuggestions(options);
        const mappedLegacySuggestions = mapNewSuggestionsToLegacySuggestions(suggestions);
        this.setState({
          suggestions: mappedLegacySuggestions
        });
      } catch (e) {
        console.error('error:', e);
      }
    }
  };

  /**
   * Getter for the input DOM element.
   *
   * @public
   * @returns {Element} - The input element.
   */
  get node() {
    return this._autosuggest.node;
  }
  render() {
    const {
      className,
      poweredByGoogleFooter,
      types,
      country,
      onClear,
      siteUrl,
      ...textInputProps
    } = this.props;
    const {
      suggestions
    } = this.state;
    const classes = (0, _classnames.default)('GooglePlacesSearchInput', className);
    return /*#__PURE__*/_react.default.createElement("div", {
      className: classes
    }, /*#__PURE__*/_react.default.createElement(_AutoSuggestInput.default, (0, _extends2.default)({
      ref: node => {
        this._autosuggest = node;
      }
    }, textInputProps, {
      onChange: this._onChange,
      suggestions: suggestions,
      types: types,
      country: country,
      suggestionBoxFooter: poweredByGoogleFooter,
      onClear: onClear,
      onSuggestionSelect: this._onSuggestionSelect,
      autoActivateFirstSuggest: true,
      siteUrl: siteUrl,
      onFocus: this._onFocus
    })));
  }
}
exports.default = GooglePlacesSearchInput;